module.exports = __webpack_public_path__ + "static/media/website.6931b35a.jpg";